import { HttpResponse, http } from 'msw';
import { API, BASE_URL_V3 } from '../../../src/common/constants';

const URL = `${BASE_URL_V3}${API.endpoints.vehicles}/:id/subscription`;

export default http.get(URL, ({ params }) => {
    const assetId = params.assetId as string;
    const subscribed = isAssetSubscribed(assetId);
    return HttpResponse.json({ status: subscribed ? 'ACTIVE' : 'INACTIVE' });
});

const isAssetSubscribed = (assetId: string) => {
    // Asset 04
    if (assetId === '040191ac-d06d-4567-b13a-7b7fd85d9739') {
        return false;
    }
    return true;
};

export const activeSubscriptionResponse = http.get(URL, () => {
    return HttpResponse.json({ status: 'ACTIVE' });
});

export const inactiveSubscriptionResponse = http.get(URL, () => {
    return HttpResponse.json({ status: 'INACTIVE' });
});

export const errorSubscriptionResponse = http.get(URL, () => {
    return HttpResponse.json({ errorMessage: 'Mock Subscription response error' }, { status: 400 });
});

// V3 handlers
export const activeSubscriptionResponseV3 = http.get(URL, () => {
    return HttpResponse.json({ status: 'ACTIVE' });
});

export const inactiveSubscriptionResponseV3 = http.get(URL, () => {
    return HttpResponse.json({ status: 'INACTIVE' });
});
